import TmrBaseResource from './TmrBaseResource'

export default class Printers extends TmrBaseResource {
  static endpoint = '/printers'
}
